export default {
  clear: 'Clear the map refinement',
  toggle: 'Search as I move the map',
  redo: 'Redo search here',
};



// WEBPACK FOOTER //
// ./src/widgets/geo-search/defaultTemplates.js